__turbopack_context__.v({
  "bar": "header-module-scss-module__Sf7jeq__bar",
  "bar--clicked": "header-module-scss-module__Sf7jeq__bar--clicked",
  "desktopCta": "header-module-scss-module__Sf7jeq__desktopCta",
  "hamburgerButton": "header-module-scss-module__Sf7jeq__hamburgerButton",
  "hamburgerIcon": "header-module-scss-module__Sf7jeq__hamburgerIcon",
  "hamburgerText": "header-module-scss-module__Sf7jeq__hamburgerText",
  "header": "header-module-scss-module__Sf7jeq__header",
  "headerContainer": "header-module-scss-module__Sf7jeq__headerContainer",
  "headerLogo": "header-module-scss-module__Sf7jeq__headerLogo",
  "headerLogo--lockup": "header-module-scss-module__Sf7jeq__headerLogo--lockup",
  "headerWrapper": "header-module-scss-module__Sf7jeq__headerWrapper",
  "megaMenu": "header-module-scss-module__Sf7jeq__megaMenu",
  "megaMenu--opened": "header-module-scss-module__Sf7jeq__megaMenu--opened",
  "mobileButtonWrapper": "header-module-scss-module__Sf7jeq__mobileButtonWrapper",
  "navContent": "header-module-scss-module__Sf7jeq__navContent",
  "navItem": "header-module-scss-module__Sf7jeq__navItem",
  "navItem--activeMenu": "header-module-scss-module__Sf7jeq__navItem--activeMenu",
  "navList": "header-module-scss-module__Sf7jeq__navList",
});
